import {
  Modal as HeroModal,
  ModalBody,
  ModalContent,
  ModalHeader, useDisclosure,
} from '@heroui/react';
import React, { FC } from 'react';

export type ModalProps = {
  isOpen: boolean;
  children: React.ReactNode;
  onClose?: () => void;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'xs' | '3xl' | '4xl' | '5xl' | 'full';
};

export const Modal: FC<ModalProps> = ({ isOpen, children, onClose, title, size }) => {
  const { onOpenChange } = useDisclosure();

  return (
    <HeroModal
      scrollBehavior="inside"
      size={size}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      backdrop="blur"
      onClose={onClose}
    >
      <ModalContent className="sm:rounded-b-lg rounded-b-none">
        <>
          <ModalHeader
            className="flex flex-col gap-1"
            style={{ fontWeight: 500, fontSize: '18px' }}
          >
            {title || ''}
          </ModalHeader>
          <ModalBody className="px-4 pb-4">
            {children}
          </ModalBody>
        </>
      </ModalContent>
    </HeroModal>
  );
};
